export default __webpack_public_path__ + "static/media/Tabl_11.48f645d6.svg";